import { TypographyKeys } from "@/theme/typography";
import { ColorKeys, createColorClasses } from "@/theme/colors";
import clsx from "clsx";
import { ReactNode } from "react";

export type TitleProps = {
  className?: string;
  id?: string;
  fs?: TypographyKeys;
  mdFs?: TypographyKeys;
  color?: ColorKeys;
  as?: "h1" | "h2" | "h3" | "h4" | "h5" | "h6";
  children: ReactNode;
};

export const Title = ({
  className,
  id,
  fs = "3",
  mdFs = "1",
  color = "slate-20",
  as = "h2",
  children,
}: TitleProps) => {
  const Heading = as;

  const createFontSizeClass = (size: TypographyKeys) => {
    return `fs-${size}`;
  };

  const fontSizeClass = createFontSizeClass(fs);
  const mdFontSizeClass = mdFs ? `md-fs-${mdFs}` : "";
  const textColorClass = createColorClasses({ text: color });

  return (
    <Heading
      id={id}
      className={clsx(
        "fw-bold",
        fontSizeClass,
        mdFontSizeClass,
        textColorClass,
        className,
      )}
    >
      {children}
    </Heading>
  );
};
